// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__eMoAQ","checkbox":"style_checkbox__B9FAY","label":"style_label__2bp_J","text":"style_text__NPnXJ"};